import { render, staticRenderFns } from "./Locationss.vue?vue&type=template&id=85eed096&scoped=true"
import script from "./Locationss.vue?vue&type=script&lang=js"
export * from "./Locationss.vue?vue&type=script&lang=js"
import style0 from "./Locationss.vue?vue&type=style&index=0&id=85eed096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eed096",
  null
  
)

export default component.exports